import { render, staticRenderFns } from "./Videoplayback.vue?vue&type=template&id=0d2974c6&scoped=true"
import script from "./Videoplayback.vue?vue&type=script&lang=js"
export * from "./Videoplayback.vue?vue&type=script&lang=js"
import style0 from "./Videoplayback.vue?vue&type=style&index=0&id=0d2974c6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2974c6",
  null
  
)

export default component.exports